/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-25 14:57:57
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-15 16:02:18
 */
import React, { useState } from "react";
import { Button, Divider, Form, message, Modal } from "antd";
import "./index.less";
import emailIcon from "@/assets/icons/account_settings/邮件@2x.png";
import userIcon from "@/assets/icons/account_settings/用户名@2x.png";
import lockIcon from "@/assets/icons/account_settings/lock.png";
import { useDispatch, useSelector } from "react-redux";
import { fetUpdateUserInfo, updatePassword } from "@/api/modules/AccountSetting";
import { ProForm, ProFormText } from "@ant-design/pro-components";
import { getCurrentUser } from "@/api/modules/user";
import { setCurrentUser } from "@/redux/modules/global/action";
import { useTranslation } from "react-i18next";

const AccountSetting = () => {
	const { t } = useTranslation();
	const formRef = React.useRef();
	const [form] = Form.useForm();

	const { currentUser } = useSelector(state => state.global);
	const dispatch = useDispatch();

	const [userName, setUserName] = useState(currentUser.nickname);
	const [showSaveButton, setShowSaveButton] = useState(false);
	const [showPasswordModal, setShowPasswordModal] = useState(false);

	let originalNickname = currentUser.nickname;

	const handleUpdateUserInfo = () => {
		if (userName.length > 20) {
			message.error(t("accountSettings.username.message.failed"));
			return;
		}

		fetUpdateUserInfo({
			username: userName
		}).then(res => {
			if (res.code === 200) {
				getCurrentUser().then(res => {
					dispatch(setCurrentUser(res.data));
				});
				originalNickname = userName;
				message.success(t("message.update.success"));
				setShowSaveButton(false);
			}
		});
	};

	const handleUpdatePassword = (originalPassword, newPassword) => {
		updatePassword({
			oldPassword: originalPassword,
			newPassword: newPassword
		}).then(res => {
			if (res.code === 200) {
				getCurrentUser().then(res => {
					dispatch(setCurrentUser(res.data));
				});
				message.success(t("message.update.success"));
				setShowPasswordModal(false);
			}
		});
	};

	return (
		<div className="accountSettingContainer">
			<div className="accountSettingContent">
				<div className="title">{t("accountSettings.title")}</div>
				<div className="formItem">
					<div className="formLabel">
						<span>
							<img className="icon" src={emailIcon} alt="" />
						</span>
						<span className="label">{t("accountSettings.email.label")}</span>
					</div>
					<div className="FormValue">{currentUser?.email}</div>
				</div>

				<div className="formItem">
					<div className="formLabel">
						<span>
							<img className="icon" src={userIcon} alt="" />
						</span>
						<span className="label">{t("accountSettings.username.label")}</span>
					</div>
					<div className="FormValue">
						<Form form={form}>
							<ProFormText
								name="userName"
								width={400}
								rules={[{ max: 20, message: t("accountSettings.username.message.failed") }]}
								fieldProps={{
									defaultValue: currentUser?.nickname,
									value: userName,

									onChange: e => {
										const newValue = e.target.value;
										setUserName(newValue);
										setShowSaveButton(true);
									}
								}}
							></ProFormText>
							{showSaveButton && (
								<div className="operationButton">
									<Button className="save" onClick={handleUpdateUserInfo}>
										{t("accountSettings.username.button.save")}
									</Button>
									<Button
										onClick={() => {
											setShowSaveButton(false);
											setUserName(originalNickname);
										}}
									>
										{t("accountSettings.username.button.cancel")}
									</Button>
								</div>
							)}
						</Form>
					</div>
				</div>

				<div className="formItem">
					<div className="formLabel">
						<span>
							<img className="icon" src={lockIcon} alt="" />
						</span>
						<span className="label">{t("accountSettings.password.label")}</span>
					</div>
					<div className="FormValue">
						<Button className="passwordButton" onClick={() => setShowPasswordModal(true)}>
							{t("accountSettings.password.button.change")}
						</Button>
					</div>
				</div>
				<Modal
					open={showPasswordModal}
					title={t("accountSettings.password.modal.title")}
					closable
					destroyOnClose
					onCancel={() => setShowPasswordModal(false)}
					okButtonProps={{
						style: {
							backgroundColor: "#565BDD"
						}
					}}
					onOk={() => {
						formRef.current?.validateFields().then(values => {
							if (values.originalPassword === values.newPassword) {
								message.error("The new password cannot be the same as the original password");
								return;
							}
							handleUpdatePassword(values.originalPassword, values.newPassword);
						});
					}}
				>
					<Divider />
					<ProForm formRef={formRef} style={{ marginTop: 30, width: "100%" }} submitter={false}>
						<ProFormText.Password
							name="originalPassword"
							label={t("accountSettings.password.modal.label.original")}
							fieldProps={{
								autoComplete: "new-password"
							}}
							style={{ marginTop: 30 }}
							rules={[
								{
									required: true,
									message: "Please enter the original password"
								}
							]}
						/>
						<ProFormText.Password
							name="newPassword"
							label={t("accountSettings.password.modal.label.new")}
							rules={[
								{
									required: true,
									message: t("tips.password.rules"),
									pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,20}$/
								}
							]}
						/>
					</ProForm>
				</Modal>
			</div>
		</div>
	);
};

export default AccountSetting;
